import dayjs, { type Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const PREFIXOS_DIA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'] as const

type PrefixoDia = (typeof PREFIXOS_DIA)[number]
type CampoHorario =
    | `${PrefixoDia}${'Ent' | 'Sai'}${1 | 2 | 3}`
    | `${PrefixoDia}Tot`

/** Colunas de horário da tabela, como a API devolve (`segEnt1`, `segTot`...). */
export type ColunasHorario = Partial<Record<CampoHorario, string | null>>

/** Lê da tabela os turnos e o total do dia da semana de `dia`. */
export function horarioDoDia(tabela: ColunasHorario, dia: Dayjs) {
    const prefixo = PREFIXOS_DIA[dia.day()]
    const turnos = ([1, 2, 3] as const)
        .map(turno => ({
            entrada: tabela[`${prefixo}Ent${turno}`] ?? '',
            saida: tabela[`${prefixo}Sai${turno}`] ?? '',
        }))
        .filter(({ entrada, saida }) => entrada || saida)

    return { turnos, total: tabela[`${prefixo}Tot`] || '00:00' }
}

type VinculoTabela = {
    dtInicial: string | Date
    dtFinal?: string | Date | null
    TabelaHorario: ColunasHorario
}

/** Dias de `dias` em que uma tabela vigente prevê horário, com a tabela do dia. */
export function diasComHorario<T extends VinculoTabela>(
    tabelas: T[],
    dias: Dayjs[],
) {
    return dias.flatMap(dia =>
        tabelas
            .filter(
                tabela =>
                    !dia.isBefore(dayjs.utc(tabela.dtInicial), 'day') &&
                    (!tabela.dtFinal ||
                        !dia.isAfter(dayjs.utc(tabela.dtFinal), 'day')) &&
                    horarioDoDia(tabela.TabelaHorario, dia).turnos.length > 0,
            )
            .map(tabela => ({ dia, tabela })),
    )
}
